/* OllieTot — Labor Day price test: discount-code guard.
   Loaded ONLY by sections/ld-offer-band.liquid. Nothing on the homepage,
   the PDPs or the cart references this file.

   The problem it solves. The ad link is
   /discount/LD50?redirect=/pages/labor-day-c, and that hop is what puts the
   code on the browser's cart. Every other way of reaching the page skips it:
   a shared link, a bookmark, a back-button return after the cookie expired,
   an in-app browser that dropped the cookie jar. Those visitors would see a
   page that says $19 and a checkout that says $38 — the exact bait-and-switch
   the pages exist to avoid.

   So: read the cart once, and if the cell's code is not on it, take one trip
   through /discount/CODE?redirect=<this page> to put it there.

   Loop safety, in order of how much each one is worth:
     1. The sessionStorage flag is written BEFORE the redirect, so even a
        redirect that fails to attach the code cannot cause a second one.
     2. If sessionStorage throws or is unavailable (Safari private mode,
        blocked site data), we return without redirecting at all. Failing
        closed here is right: an unguarded redirect is a loop, and a visitor
        who merely sees the undiscounted cart is recoverable.
     3. The control cell has no code, so this is a no-op there.
     4. Anything unexpected — non-OK response, malformed JSON, no cart — is
        swallowed and the page is left alone. */
(function () {
  "use strict";

  var root = document.querySelector("[data-ld-code]");
  if (!root) return;

  var code = (root.getAttribute("data-ld-code") || "").trim();
  if (!code) return;                       // control cell: nothing to apply

  var flag = "ld_discount_attempt:" + code;
  try {
    if (window.sessionStorage.getItem(flag)) return;
  } catch (err) {
    return;                                // no storage, no guard, no redirect
  }

  var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";

  fetch(base + "cart.js", {
    headers: { Accept: "application/json" },
    credentials: "same-origin"
  })
    .then(function (res) { return res.ok ? res.json() : null; })
    .then(function (cart) {
      if (!cart) return;
      // /cart.js reports discount_codes even on an empty cart — the code
      // rides along with applicable:false until there is something to apply
      // it to, so presence is the test, not applicability.
      var codes = cart.discount_codes || [];
      var wanted = code.toUpperCase();
      for (var i = 0; i < codes.length; i++) {
        var have = codes[i] && codes[i].code;
        if (have && String(have).toUpperCase() === wanted) return;
      }

      // Mark first, navigate second.
      try {
        window.sessionStorage.setItem(flag, "1");
      } catch (err) {
        return;
      }

      var here = window.location.pathname + window.location.search;
      window.location.replace(
        base + "discount/" + encodeURIComponent(code) +
        "?redirect=" + encodeURIComponent(here)
      );
    })
    .catch(function () { /* leave the page exactly as it is */ });
})();
